import GButton from "./";

<template>
  <GButton
    @type={{@type}}
    @color={{if @color @color "green"}}
    @disabled={{@disabled}}
    @loading={{@loading}}
    @display={{if @display @display "compact"}}
    ...attributes
  >
    <div class="flex items-center">
      {{yield}}
    </div>
  </GButton>
</template>
